module.exports = __webpack_public_path__ + "static/media/34DSS5.56d15129.jpg";